import { useState, useEffect } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const galleryImages = [
  "/gallery/gallery1.jpeg",
  "/gallery/gallery2.jpeg",
  "/gallery/gallery3.jpg",
  "/gallery/gallery4.jpeg",
  "/gallery/gallery5.jpeg",
  "/gallery/gallery6.jpeg",
  "/gallery/gallery7.jpeg",
  "/gallery/gallery8.jpeg",
  "/gallery/gallery9.jpeg",
  "/gallery/gallery10.jpeg",
  "/gallery/gallery11.jpeg",
  "/gallery/gallery12.jpeg",
  "/gallery/gallery13.jpeg",
  "/gallery/gallery14.jpeg",
  "/gallery/gallery15.jpeg",
  "/gallery/gallery16.jpeg",
  "/gallery/gallery17.jpeg",
];

export default function Gallery() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Lock scroll
  useEffect(() => {
    document.body.style.overflow =
      selectedIndex !== null ? "hidden" : "auto";
  }, [selectedIndex]);

  const nextImage = () => {
    setSelectedIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  return (
<section
  id="gallery"
  className="py-20 px-6 bg-gradient-to-b from-black to-gray-900 text-white"
>
      
      {/* Heading */}
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#D4AF37]">
        Gallery
      </h2>

      {/* Grid */}
      <div id="photos">

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {galleryImages.map((img, index) => (
          <div
            key={index}
            className="relative group overflow-hidden rounded-xl shadow-lg cursor-pointer"
            onClick={() => setSelectedIndex(index)}
          >
            <img
              src={img}
              alt=""
              className="w-auto h-100 object-cover transition duration-500 group-hover:scale-110"
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition">
              <span className="text-white text-2xl">🔍</span>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50"
          onClick={() => setSelectedIndex(null)}
        >
          {/* Close */}
          <button
            className="absolute top-5 right-5 text-white text-2xl"
            onClick={() => setSelectedIndex(null)}
          >
            <FaTimes />
          </button>

          {/* Prev */}
          <button
            className="absolute left-5 text-white text-3xl"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            <FaChevronLeft />
          </button>

          {/* Image */}
          <img
            src={galleryImages[selectedIndex]}
            alt=""
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] max-w-[90vw] rounded-xl shadow-2xl animate-fadeIn"
          />

          {/* Next */}
          <button
            className="absolute right-5 text-white text-3xl"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            <FaChevronRight />
          </button>
        </div>
      )}
      </div>
      
    </section>
  );
}